var $3c220ae7ef8a35fd$exports = {};
$3c220ae7ef8a35fd$exports = {
    "dismiss": `Dispensar`
};


export {$3c220ae7ef8a35fd$exports as default};
//# sourceMappingURL=pt-PT.mjs.map
